import { useHandleActionItem } from '@/components/hooks/useHandleActionItem';
import { Button } from 'antd';
import React from 'react';
import { CourseProvider } from '../context';
import { Authorize } from '@/core';
import { PERMISSIONS } from '@/contants';
import { CourseTable } from './List/CourseTable';
import { DetailCourse } from './Form';

export const CourseScreen: React.FC<unknown> = () => {
  const { open, handleClose, setOpen, handleClickCreate } = useHandleActionItem();

  return (
    <>
      <CourseProvider>
        <div className='bg-white py-4 px-4 flex flex-col flex-wrap'>
          <div className='ml-auto'>
            <Button
              type='primary'
              size='middle'
              onClick={() => handleClickCreate()}
              className='rounded'
            >
              + Create
            </Button>
          </div>
          <div className='w-full mt-2'>
            <CourseTable />
            <DetailCourse open={open} handleClose={handleClose} setOpen={setOpen} />
          </div>
        </div>
      </CourseProvider>
    </>
  );
};

export const CourseList = Authorize<unknown>(CourseScreen, PERMISSIONS.COURSE.VIEW);
